import { createSelector } from '@reduxjs/toolkit';
import { selectAllIssues } from '@ui/features/quote-builder/state/selectors/issue';
import { RootState } from '@ui/store';

import { getIssues, getQuotePriceOrThrow } from '../utilities/selector-guards';

export const selectQuotePrice = (
  state: RootState,
  quoteLineUuid: string,
  quotePriceUuid: string,
) => {
  return getQuotePriceOrThrow(
    state.quoteBuilder,
    quoteLineUuid,
    quotePriceUuid,
  );
};

export const selectQuotePriceAndIssues = createSelector(
  [
    selectAllIssues,
    selectQuotePrice,
    (_, quoteLineUuid: string) => quoteLineUuid,
    (_, __, quotePriceUuid: string) => quotePriceUuid,
  ],
  (issues, quotePrice, quoteLineUuid, quotePriceUuid) => {
    const quotePriceIssues = getIssues(issues, {
      area: 'quotePrice',
      quoteLineUuid,
      quotePriceUuid,
    });

    return { quotePrice, issues: quotePriceIssues };
  },
);
